export function isTauri(): boolean {
  return typeof window !== "undefined" && !!(window as any).__TAURI_INTERNALS__;
}

export async function tauriInvoke<T = any>(cmd: string, payload?: any): Promise<T> {
  if (!isTauri()) throw new Error("Not running inside Tauri");
  const { invoke } = await import("@tauri-apps/api/core");
  return invoke<T>(cmd, payload);
}
